"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));

var _constants = require("../link/constants");

var _constants2 = require("../popover/constants");

var _context = require("../context");

var _utils = require("../utils");

var _constants3 = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["isInline", "triggerRef", "tooltipRef", "WrappedComponent", "useTriggerWrapper", "open", "close", "isOpen", "tooltipId", "tooltipDataTestId", "verticalAlign", "externalRef", "delayOnHoverDuration", "setHasOpenedDialog"],
    _excluded2 = ["setHasOpenedDialog"],
    _excluded3 = ["setHasOpenedDialog"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TriggerWrapper = (0, _context.styledWithTheme)('div')(function (_ref) {
  var isInline = _ref.isInline,
      theme = _ref.theme,
      verticalAlign = _ref.verticalAlign;
  return _objectSpread({
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    verticalAlign: verticalAlign,
    borderRadius: theme.selectors.radius(_constants.INLINE_BORDER_RADIUS),
    ':focus': {
      outline: "2px solid ".concat(theme.selectors.color('primary70')),
      outlineOffset: 2
    }
  }, isInline ? {} : {
    minHeight: _utils.A11Y_MIN_SIZE_2_5_8,
    minWidth: _utils.A11Y_MIN_SIZE_2_5_8
  });
});
TriggerWrapper.displayName = 'TriggerWrapper';

var TooltipTrigger = /*#__PURE__*/_react.default.memo(function (_ref2) {
  var isInline = _ref2.isInline,
      triggerRef = _ref2.triggerRef,
      tooltipRef = _ref2.tooltipRef,
      WrappedComponent = _ref2.WrappedComponent,
      useTriggerWrapper = _ref2.useTriggerWrapper,
      open = _ref2.open,
      close = _ref2.close,
      isOpen = _ref2.isOpen,
      tooltipId = _ref2.tooltipId,
      tooltipDataTestId = _ref2.tooltipDataTestId,
      verticalAlign = _ref2.verticalAlign,
      externalRef = _ref2.externalRef,
      delayOnHoverDuration = _ref2.delayOnHoverDuration,
      setHasOpenedDialog = _ref2.setHasOpenedDialog,
      passthroughProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var hoverTimer = (0, _react.useRef)();
  var handleMouseMove = (0, _react.useCallback)(function (e) {
    var clientX = e.clientX,
        clientY = e.clientY; // detect boundaries of tooltip trigger and tooltip body to not close them on hovering

    if (triggerRef.current) {
      var _triggerRef$current$g = triggerRef.current.getBoundingClientRect(),
          triggerTop = _triggerRef$current$g.top,
          triggerLeft = _triggerRef$current$g.left,
          triggerBottom = _triggerRef$current$g.bottom,
          triggerRight = _triggerRef$current$g.right;

      if (clientX >= triggerLeft && clientX <= triggerRight && clientY >= triggerTop && clientY <= triggerBottom) {
        return;
      }
    }

    if (tooltipRef.current) {
      var _tooltipRef$current$g = tooltipRef.current.getBoundingClientRect(),
          tooltipTop = _tooltipRef$current$g.top,
          tooltipLeft = _tooltipRef$current$g.left,
          tooltipBottom = _tooltipRef$current$g.bottom,
          tooltipRight = _tooltipRef$current$g.right;

      if (clientX >= tooltipLeft && clientX <= tooltipRight && clientY >= tooltipTop - _constants2.ARROW_HEIGHT && clientY <= tooltipBottom + _constants2.ARROW_HEIGHT) {
        return;
      }
    }

    if (!isFocused) {
      document.removeEventListener('mousemove', handleMouseMove);

      if (hoverTimer.current) {
        window.clearTimeout(hoverTimer.current);
        hoverTimer.current = undefined;
      }

      close();
    }
  }, [tooltipRef, triggerRef, close, isFocused]);

  var handleMouseOver = function handleMouseOver() {
    document.addEventListener('mousemove', handleMouseMove);

    if (delayOnHoverDuration) {
      if (!hoverTimer.current) {
        hoverTimer.current = window.setTimeout(function () {
          return open();
        }, Math.max(0, Math.min(delayOnHoverDuration, _constants3.MAX_HOVER_DELAY_DURATION)));
      }
    } else {
      open();
    }
  };

  var handleKeyDownOnFocus = (0, _react.useCallback)(function (e) {
    if (e.key === _utils.EventKeys.SPACEBAR && e.target.type !== 'button') {
      e.preventDefault();
    }
  }, []);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (isOpen && e.key === _utils.EventKeys.ESCAPE) {
      e.stopPropagation();
      close();
    }
  }, [close, isOpen]);
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeyDown, true);
    return function () {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [handleKeyDown]);
  (0, _react.useEffect)(function () {
    setHasOpenedDialog(isOpen);
    return function () {
      return setHasOpenedDialog(false);
    };
  }, [setHasOpenedDialog, isOpen, isFocused]);

  var toggleIsFocused = function toggleIsFocused() {
    if (isFocused) {
      if (hoverTimer.current) {
        window.clearTimeout(hoverTimer.current);
        hoverTimer.current = undefined;
      }

      close();
    } else {
      open();
    }

    setIsFocused(function (prev) {
      return !prev;
    });
  };

  (0, _react.useEffect)(function () {
    return function () {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [handleMouseMove]);
  var triggerProps = {
    'aria-describedby': tooltipId,
    onMouseOver: handleMouseOver,
    onFocus: toggleIsFocused,
    onBlur: toggleIsFocused,
    onKeyDown: handleKeyDownOnFocus
  };
  var triggerPropsForNonInteractiveComponents = {
    tabIndex: 0,
    role: 'button'
  };
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactTooltipTrigger',
    dataTestId: tooltipDataTestId
  });

  if (useTriggerWrapper) {
    return (0, _core.jsx)(TriggerWrapper, (0, _extends2.default)({
      isInline: isInline
    }, dataTestProps, triggerProps, triggerPropsForNonInteractiveComponents, {
      ref: (0, _utils.mergeRefs)(triggerRef, externalRef),
      verticalAlign: verticalAlign
    }), (0, _core.jsx)(WrappedComponent, passthroughProps));
  }

  return (0, _core.jsx)(WrappedComponent, (0, _extends2.default)({}, dataTestProps, triggerProps, passthroughProps, {
    ref: triggerRef
  }));
}, function (_ref3, _ref4) {
  var setHasOpenedDialogPrev = _ref3.setHasOpenedDialog,
      prev = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
  var setHasOpenedDialogNext = _ref4.setHasOpenedDialog,
      next = (0, _objectWithoutProperties2.default)(_ref4, _excluded3);
  return (// Do not rerender when context changes as it's not needed
    (0, _reactFastCompare.default)(prev, next) && !!setHasOpenedDialogPrev && !!setHasOpenedDialogNext
  );
});

TooltipTrigger.displayName = 'TooltipTrigger';

var TooltipTriggerWithContext = function TooltipTriggerWithContext(props) {
  var _useContext = (0, _react.useContext)(_context.StencilDialogContext),
      setHasOpenedDialog = _useContext.setHasOpenedDialog;

  return (0, _core.jsx)(TooltipTrigger, (0, _extends2.default)({}, props, {
    setHasOpenedDialog: setHasOpenedDialog
  }));
};

TooltipTriggerWithContext.displayName = 'TooltipTriggerContext';
var _default = TooltipTriggerWithContext;
exports.default = _default;